import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'userProfile',
    path: '/user-profile',
    component: () => import('../pages/UserProfilePage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
